import HomeCard from "../../../UI/HomeCard";
import { BsCodeSlash } from "react-icons/bs";

const Backend = () => {
  return (
    <HomeCard>
      <h2>
        <BsCodeSlash /> BACKEND DEVELOPMENT
      </h2>

      <p>
        I have experience working with backend technologies to support frontend
        applications, focusing on API development and data handling.
      </p>

      <div>
        What I can help you with:
        <ul>
          <li>Developing backend APIs using Node.js and Express.js</li>
          <li>Integrating frontend applications with backend services</li>
          <li>Working with databases and structured data</li>
          <li>Supporting authentication, data flow, and server-side logic</li>
        </ul>
      </div>
    </HomeCard>
  );
};

export default Backend;
